import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from "@angular/core";
import {Cohort} from "../../model/cohort";
import {Criterion} from "../../model/criterion";

@Component({
  selector: 'gen-cohort-container',
  templateUrl: './cohort-container.component.html',
  styleUrls: ['./cohort-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CohortContainerComponent {

  @Input() cohort: Cohort;
  @Input() enableCohortDragging: boolean;
  @Output() cloneMe = new EventEmitter<Cohort>();
  @Output() deleteMe = new EventEmitter<Cohort>();
  @Output() enableDraggable = new EventEmitter<boolean>();
  editMode: boolean;

  public formName: string;

  constructor() {
  }

  ngOnInit() {
  }

  enterEditMode() {
    if (!this.cohort.criteria) {
      this.cohort.criteria = [new Criterion("any"), new Criterion("none")];
    }
    this.editMode = true;
    this.enableDraggable.emit(!this.editMode);
  }

  enterViewMode() {
    this.editMode = false;
    this.enableDraggable.emit(!this.editMode);
  }

  onCloneMe() {
    this.editMode = false;
    this.cloneMe.emit(this.cohort);
  }

  onDeleteMe() {
    this.deleteMe.emit(this.cohort);
  }

}
